export default __webpack_public_path__ + "images/AB.c99bc6d.png";